export default __webpack_public_path__ + "static/media/placeHolder.2fd929c7.jpg";